import React, { useCallback, useEffect, useState } from 'react'
import PasswordPolicyForm from '@/components/administration/passwordPolicy'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import { openAlertDialog, openErrorDialog } from '@/utils/dialogHelpers'

function PasswordPolicyPasswordTab () {
  const [ passwordPolicy, setPasswordPolicy ] = useState(null)
  const [ updating, setUpdating ] = useState(false)

  const { localize } = useLocalization()

  useEffect(() => {
    context.api.passwordPolicyService.get()
      .then(x => {
        setPasswordPolicy({
          ...x,
          originalIsTwoFactorAuthenticationRequired: x.isTwoFactorAuthenticationRequired
        })
      })
      .catch(openErrorDialog)
  }, [])

  const onSave = useCallback((input) => {
    setUpdating(true)
    context.api.passwordPolicyService.save(input)
      .then(() => {
        openAlertDialog({ title: 'Common.Success', text: 'Security.PasswordPolicySaved' })
        setUpdating(false)
      })
      .catch(openErrorDialog)
  }, [])

  const onForceUsersToChangePasswordAtNextLogon = useCallback(() => {
    setUpdating(true)
    context.api.passwordPolicyService.forceUsersToChangePasswordAtNextLogon()
      .then(() => setUpdating(false))
      .catch(openErrorDialog)
  }, [])

  return !passwordPolicy ? '' : <PasswordPolicyForm
    localize={localize}
    fetching={!passwordPolicy}
    updating={updating}
    forcingPasswordChange={updating}
    save={onSave}
    forceUsersToChangePasswordAtNextLogon={onForceUsersToChangePasswordAtNextLogon}
    {...passwordPolicy} />
}

export default PasswordPolicyPasswordTab



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/passwordPolicy/PasswordPolicyPasswordTab.js